export const getStreamableUrl = (url) => {
  if (String(url).includes("instagram"))
    return `https://autumn-sun-3d36.shivamarora41195.workers.dev/${url}`;
  return url;
};
